export default function AboutSection() {
    return (
      <section className="bg-[#F9F9F9] py-20 lg:py-32 xl:px-32 px-6 relative">
        <div className="absolute bottom-0 left-0  z-10">
          <img src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763709523/image_28_1_d0snbo.png" alt="About Section Background" className="w-[277px] h-[230px] object-cover object-center" />
        </div>
        <div className="max-w-[1360px] mx-auto relative z-20">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            
            <div className="space-y-6 text-[#677078] text-[17px]  mb-10">
                <p>
                  Alphaden Exploration & Production is an independent energy and oilfield solutions
                  company helping operators drill faster, safer, and at a lower total cost. We combine
                  globally certified equipment, practical financing models, and robust in-country
                  execution to move projects seamlessly from concept to operation.
                </p>
  
                <p>
                  Our strength lies in strategic partnerships with world-class Original Equipment
                  Manufacturers — and the ability to integrate, commission, finance, and support their
                  systems with full accountability throughout the project lifecycle.
                </p>
              </div>

              <div>
              <div className="mb-4">
                <span className="text-[#E37D33] font-medium text-lg ">
                  Who we are
                </span>
              </div>
  
              <h2 className="text-4xl sm:text-[42px] font-medium text-[#010305] mb-8">
                For operators who expect great results
              </h2>
  
             
  
              <button className="group bg-[#00458F] hover:bg-blue-700 text-white font-semibold px-5 py-[18px]  transition-all duration-300 flex items-center gap-2 shadow-lg hover:shadow-xl hover:scale-105">
                Learn more
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </button>
              </div>
            </div>
          </div>
      </section>
    );
  }